const NewGameDetailRouter = [
  {
    path: '/new-game-detail/:gameId/basketball-player-stats',
    name: 'NewGameDetailBasketballPlayerStats',
    component: () => import('@/views/new-game-detail/basketball-player-stats.vue'),
    meta: {
      title: '球员数据',
    }
  },
  {
    path: '/new-game-detail/:gameId/home',
    name: 'NewGameDetailHome',
    component: () => import('@/views/new-game-detail/home.vue'),
    meta: {
      title: '比赛详情',
    }
  },
  {
    path: '/new-game-detail/:gameId/wheel-battle',
    name: 'NewGameDetailWheelBattle',
    component: () => import('@/views/new-game-detail/wheel-battle.vue'),
    meta: {
      title: '车轮详情',
    }
  }
]

export default NewGameDetailRouter